import { render } from "./BodyScheme.vue?vue&type=template&id=a91ce43c&scoped=true&ts=true"
import script from "./BodyScheme.vue?vue&type=script&lang=ts"
export * from "./BodyScheme.vue?vue&type=script&lang=ts"

import "./BodyScheme.vue?vue&type=style&index=0&id=a91ce43c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a91ce43c"]])

export default __exports__